const Colors = {
  primary: "#001f3f", // Navy Blue
  tableGradient: "linear-gradient(182.15deg, #001f3f -77.31%, #005f73 97.38%)",
  primaryGradient: "linear-gradient(94.06deg, #001f3f -1.21%, #004080 50.75%, #003366 102.71%)",
  primaryGradient2: "linear-gradient(180deg, #001f3f 0%, #004080 100%)",
  secondary: "#0f1b24",
  textSecondary: "#14212a",
  cloudyGrey: "#666666",
  darkGrey: "#333333",
  charcoalGrey: "#323B4B",
  Martini: "#A3A3A3",
  grey: "#b3b3b3",
  greyCloud: "#B2B5BA",
  cloud: "#c2c2c2",
  iron: "#d9d9d9",
  lightGrey: "#797979",
  greyShade: "#959595",
  smokeyGrey: "#747474",
  water: "#DBE1EB",
  dawnPink: "#F8E4E4",
  white: "#ffffff",
  whiteSmoke: "#F3F3F3",
  milkWhite: "#FAFBFC",
  flashWhite: "#EFF0F6",
  lightPink: "#FEF8F8",
  mercury: "#DFE5EB",
  iceBerg: "#D2F2FF",
  aliceBlue: "#EAF9FF",
  feta: "#EEFBEE",
  yellow: "#FFF500",
  softPeach: "#ECEDF4",
  black: "#222222",
  mirage: "#15142A",
  blueWhale: "#082B43",
  darkCerulean: "#094771",
  smokyBlack: "#0707074d",
  blackShade: "#0f1b24de",
  bluishCyan: "#27ADDF",
  danger: "#d32f2f",
  success: "#4caf50",
  whatsapp: "#075e54",
  facebook: "#3b5999",
  linkedin: "#0A66C2",
  twitter: "#55acee",
  instagram: "#e4405f",
  youtube: "#cd201f",
  blue: "#1e90ff",
  invoice: "#ed893e",
  urgent: "#E4432E",
  fullTime: "#1E3A8A", // darker blue tone
  partTime: "#3B82F6", // medium blue tone
  borderIron: "#EAEAEA",
  facebook2: "#316FF6",
  instagram2: "#FA7E1E",
  linkedin2: "#0077B5",
};

export default Colors;
